import type { RelicFeedbackTriggerKey } from './types';

function signed(n: number, suffix: string) {
  return `${n >= 0 ? '+' : ''}${n} ${suffix}`;
}

function plural(n: number, one: string, many: string) {
  return n === 1 ? one : many;
}

export function formatRelicFeedbackText(
  trigger: RelicFeedbackTriggerKey,
  amount?: number
): string | undefined {
  switch (trigger) {
    case 'startArmor':
      return amount != null ? `+${amount} Armor` : undefined;
    case 'startHp':
      return amount != null ? signed(amount, 'HP') : undefined;
    case 'startSp':
      return amount != null ? signed(amount, 'SP') : undefined;
    case 'startReflectPct':
      return amount != null ? `${amount}% Reflect gained` : undefined;
    case 'startNegateNextDamage':
      return amount != null ? `Next ${amount} hit${amount === 1 ? '' : 's'} negated` : undefined;
    case 'startNextCardCost0':
      return 'Next card costs 0';

    case 'turnStartAttackBonus':
      return amount != null ? `Next Attack +${amount}` : undefined;
    case 'turnStartArmor':
      return amount != null ? `+${amount} Armor` : undefined;

    case 'firstTurnExtraDraw':
      return amount != null ? `+${amount} ${plural(amount, 'card', 'cards')} drawn` : undefined;
    case 'drawBeyondFirstGainSp':
      return amount != null ? `+${amount} SP gained` : undefined;
    case 'fullHandGainHpOnDraw':
      return amount != null ? `+${amount} HP gained` : undefined;

    case 'onDiscardGainSp':
      return amount != null ? `+${amount} SP gained` : undefined;
    case 'onDiscardGainHp':
      return amount != null ? `+${amount} HP gained` : undefined;

    case 'delayCardArmor':
      return amount != null ? `+${amount} Armor gained` : undefined;
    case 'spGainWhenZero':
      return amount != null ? `+${amount} SP gained` : undefined;

    case 'reflectBonusHp':
      return amount != null ? `+${amount} HP gained` : undefined;
    case 'reflectBonusSp':
      return amount != null ? `+${amount} SP gained` : undefined;
    case 'reflectBonusDraw':
      return amount != null ? `+${amount} ${plural(amount, 'card', 'cards')} drawn` : undefined;
    case 'attackBonusFlat':
      return amount != null ? `+${amount} dmg` : undefined;

    case 'attackBonusWhenLowSp':
      return amount != null ? `+${amount} dmg` : undefined;
    case 'attackBonusWhenArmorZero':
      return amount != null ? `+${amount} dmg` : undefined;

    case 'endTurnEmptyDraw':
      return amount != null ? `+${amount} ${plural(amount, 'card', 'cards')} drawn` : undefined;
    case 'endTurnFiveCardsArmor':
      return amount != null ? `+${amount} Armor` : undefined;
    case 'endTurnArmorPerCard':
      return amount != null ? `+${amount} Armor` : undefined;

    case 'chainCostReduction':
      return amount != null ? `-${amount} SP cost` : undefined;
    case 'delayCostReduction':
      return amount != null ? `-${amount} SP cost` : undefined;
    case 'addendumCostReduction':
      return amount != null ? `-${amount} SP cost` : undefined;
    case 'damageReductionIfLargeDeck':
      return amount != null ? `-${amount} dmg taken` : undefined;
    case 'reduceDelayForLargeDeck':
      return amount != null ? `Delay -${amount}` : undefined;
    case 'doubleArmorGainFromCards':
      return amount != null ? `+${amount} bonus Armor` : undefined;
    case 'firstExileDontExile':
      return 'Exile prevented';

    case 'immuneStun':
      return 'Stun negated';
    case 'focusBonusSP':
      return amount != null ? `+${amount} SP gained` : undefined;
    case 'focusBonusHP':
      return amount != null ? `+${amount} HP gained` : undefined;
    case 'recastDrawPenalty':
      return amount != null ? `+${amount} ${plural(amount, 'card', 'cards')} redrawn` : undefined;

    default:
      return undefined;
  }
}